export default "__VITE_ASSET__BImMvsG0__"